"use strict";
exports.__esModule = true;
exports.chart_color_red_200 = {
  "name": "--pf-chart-color-red-200",
  "value": "#a30000",
  "var": "var(--pf-chart-color-red-200, #a30000)"
};
exports["default"] = exports.chart_color_red_200;